import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import BaseButton from "@/components_v2/Button/BaseButton";
import {
  BUTTON_SIZES,
  BUTTON_TARGETS,
  BUTTON_TYPES,
} from "@/components_v2/Button/constants";
import { selectCurrentUser } from "@/redux/authentication/selectors";
import { formatCertificationDate } from "@/domains/certifications/utils";
import { CertificatePanelProps } from "@/features/certifications/overview/components/types";

import "./styles.css";

const CertificatePanel = ({
  credential,
  certificateTitle,
  programmeTitle,
}: CertificatePanelProps) => {
  const { t } = useTranslation();
  const user = useSelector(selectCurrentUser);

  return (
    <div className="certificate-panel flex flex-wrap items-center gap-400">
      <div
        className="certificate-preview flex flex-col justify-center gap-100"
        aria-hidden
      >
        <span className="certificate-preview-eyebrow body-xs-regular">
          {t("certification.overview.certificate.eyebrow")}
        </span>

        <span className="certificate-preview-title body-s-medium">
          {certificateTitle}
        </span>

        {user?.fullName && (
          <span className="body-xs-regular">{user.fullName}</span>
        )}

        <span className="certification-muted body-xs-regular">
          {programmeTitle}
        </span>
      </div>

      <div className="flex flex-col gap-200 flex-1">
        <h3 className="certification-heading body-m-medium">
          {t("certification.overview.certificate.earned", {
            title: certificateTitle,
          })}
        </h3>

        {credential.issuedAt && (
          <span className="certification-muted body-s-regular">
            {t("certification.overview.certificate.issuedOn", {
              date: formatCertificationDate(credential.issuedAt),
            })}
          </span>
        )}

        {credential.externalUrl && (
          <div>
            <BaseButton
              type={BUTTON_TYPES.LINK}
              size={BUTTON_SIZES.SMALL}
              to={credential.externalUrl}
              target={BUTTON_TARGETS.BLANK}
            >
              {t("certification.overview.certificate.view")}
            </BaseButton>
          </div>
        )}
      </div>
    </div>
  );
};

export default CertificatePanel;
